<template>
<div>
  <div class="chart">
      <chart-pie :data-list="pieData" :extra-option="option" />
  </div>
  </div>
</template>

<script>
import ChartPie from "@/components/echarts/echart_pie/EchartPie.vue";
export default {
  components: {
    ChartPie
  },
  data() {
    return {
      // 业务数据
      pieData: [
        {
          name: "西瓜",
          value: 20
        },
        {
          name: "橘子",
          value: 13
        },
        {
          name: "杨桃",
          value: 33
        }
      ],
      // 定制化配置覆盖默认配置
      option: {
        color: ["#e033f7", "#15c28e", "#2267e6"],
        title:{text:'用电总数(kwh)'},
        graphic:{style:{text:"11.11"}}
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chart{
    width:100%;
    height:300px;
}
</style>